<template>
  <div class="model check" :style="{ top: cvDetail.basic_info.mentor_id ? '56px' : 0 ,zIndex: !hasJobscanRepor && isShowJobscanGuide ? 10 : 8 }">

    <!-- 检查分数模块 -->
    <div class="check-box">

      <!-- 分数和检查按钮 -->
      <div class="check-title">
        <div class="score-content">
          <span class="score-number">{{score || 0}}</span>
          <span class="score-text">分</span>
        </div>
        <button @click="check()">智能检查</button>
      </div>

      <!-- 进度条 -->
      <div class="check-progress">
        <div :style="{width: (score || 0) + '%'}"></div>
      </div>

      <!-- 导师辅导入口 -->
      <a class="mentor-entry-box" :href="`https://www.wondercv.${suffix}/service/`" target="__blank">
        <div class="mentor-entry-avatar">
          <a class="mentor-entry-image" :href="`https://www.wondercv.${suffix}/service/`" target="__blank"></a>
        </div>
        <!-- <img src="https://files.wondercv.com/pc-vue/editor/mentor-entry-avatar.png" alt="" class="mentor-entry-avatar"> -->
        <p v-html="desc"></p>
      </a>

    </div>
    <!-- jobscan 入口 -->
    <!--
      <div class="jobscan-box" @click="toTestPage" v-if="cvDetail && cvDetail.basic_info.score > 80 && !hasJobscanRepor && !isMentorEditor && cvDetail.basic_info.lang === 'cn'"  :class="[!hasJobscanRepor && isShowJobscanGuide ? 'jobscan-active' : '']">
      <p class="jobscan-title">你的简历和职位匹配吗？</p>
      <p class="jobscan-content">求职黑科技来帮你：简历和目标职位到底还有哪些差距？针对性优化提升 3 倍通过率！</p>
    </div>-->
    <!-- <div v-if="cvDetail && cvDetail.basic_info.score <= 80" @click="toLink" class="cursor_p">
      <img :src="checkBanner.image" class="check-banner" alt="">
    </div> -->
    <!-- <div  class="edit_body">
      <div class="list-header-main-banner cursor_p">
        <el-carousel  style="height: 92px" >
          <el-carousel-item v-for="(item, index) in imgbanner" :key="index" >
            <img class="check-banner "  :src="item.image" alt=""  @click="toLink(item)" >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->
    <!-- <div  v-if="cvDetail && cvDetail.basic_info.score <= 80 && imgbanner.length > 0" class="edit_body">
      <div class="list-header-main-banner cursor_p" :class="{'more-banner': imgbanner.length === 1}">
        <el-carousel >
          <el-carousel-item v-for="(item, index) in imgbanner" :key="index" >
            <img class="check-banner " :src="item.image" alt=""  @click="toLink(item)" >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div  v-if="cvDetail && cvDetail.basic_info.score > 80 && imgbanner2.length > 0" class="edit_body">
      <div class="list-header-main-banner cursor_p" :class="{'more-banner': imgbanner2.length === 1}">
        <el-carousel >
          <el-carousel-item v-for="(item, index) in imgbanner2" :key="index" >
            <img class="check-banner " :src="item.image" alt=""  @click="toLink(item)" >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->
    <!-- 隐私入口 -->
    <!-- <div class="privacy-entry-box">
      <p>设置简历推荐，让 offer 找到你</p>
      <a href="/account/users?index=2" target="_blank">去设置</a>
      <img src="https://files.wondercv.com/pc-vue/editor/privacy-entry-bg.png" alt="" class="privacy-entry-bg">
    </div> -->


    <!-- <div class="check-msg" style="min-height: 10px;">
      <p v-html="desc"></p>
      <li class="check-item" v-if="(isCanRecommend || hasRecommendCv) ">
        <span>设置简历推荐，让 offer 找到你</span>
        <a href="/account/users?index=2" target="_blank">去设置</a>
      </li>
      <li class="check-item">
        <span>快看！有 16 个高薪职位发布啦</span>
        <a href="/jobs/search" target="_blank">去看职位</a>
      </li>
    </div> -->

    <!-- 引导遮挡 -->
    <div @click="setIsShowJobscanGuide(false)" :class="[ !hasJobscanRepor && isShowJobscanGuide && cvDetail.basic_info.lang === 'cn' && !isMentorEditor ? 'jobscan-layer' : '']"></div>
    <div @click="setIsShowJobscanGuide(false)" :class="[ !hasJobscanRepor && isShowJobscanGuide && cvDetail.basic_info.lang === 'cn' && !isMentorEditor ? 'jobscan-layer jobscan-layer-bottom' : '']"></div>

    <!-- 纠错模式下，功能不可用 -->
    <div class="open-resume-error-cover-up" v-show="openResumeError" @click.stop="showCloseResumeError()"></div>

  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
  import { get_tUser } from '../../../../../assets/js/util'
  import api from "../../../../../api"
	const moment = require('moment')
  import { cvResumeErrorMixin } from '@/assets/js/mixins'
  import {alertData} from "@/store/app/state";

	export default {
		name: 'Check',
		props: {
			notMemberAgainCheck: {
				type: Boolean,
				default: false
			}
		},
    mixins: [cvResumeErrorMixin],
		data () {
			return {
				ischecked: false,
        hasRecommendCv: false,
        // checkBanner: '',
        imgbanner:[],
        position:'',
        imgbanner2:[]
			}
		},
    created() {
      this.getBanner()
    },
    mounted() {
      // this.getRecommendCvData()
    },
		computed: {
			...mapState('editor', [ 'cvToken', 'checkData', 'score', 'cvDetail', 'readyScore', 'syncSuccess', 'hasJobscanRepor', 'isShowJobscanGuide', 'profile', 'openResumeError' ]),
			...mapState('me', []),
      ...mapState('cv', ['cvs']),
			// 分数对应的分数文案
			desc () {
				let score_desc = ''
        let { name } = this.profile
				if (this.readyScore <= 40)
					score_desc = `👋 Hi ${this.profile.username || ''}，你只打败了 2% 用户，参考优化建议，继续完善简历吧~`
				if (this.readyScore <= 59 && this.readyScore >= 41)
					score_desc = `💪 加油${this.profile.username || ''}，差一点就 60 分啦，根据建议修改，快速提升简历`
				if (this.readyScore <= 79 && this.readyScore >= 60)
					score_desc = `💪 加油${this.profile.username || ''}，简历达到 80 分，面试成功率将提升 90% 以上！`
				if (this.readyScore <= 99 && this.readyScore >= 80)
					score_desc = `👏 ${this.profile.username || ''}，差一点点就100分啦，挑战满分💯 还是去投递试试？`
				if (this.readyScore === 100)
					score_desc = `🎊 恭喜获得满分，超过 99.8% 的求职者！`
				return score_desc
			},
      // 环境
      suffix () {
        let suffix = process.env.NODE_ENV === 'development' ? 'cn' : 'com'
        return suffix
      },
      isCanRecommend() {
        return !!(this.cvs.filter(item => item.can_editable && !item.is_mentor && item.lang === 'cn').length)
      },
      isMentorEditor () {
        return window.location.href.includes('mentor')
      },
		},
		methods: {
			...mapActions('editor', [ 'getCheckData', 'getCvPortrait' ]),
			...mapActions('app', [ 'setAlertData' ]),
			...mapMutations('editor', [ 'setCheckData', 'setIsShowJobscanGuide' ]),
      async getBanner() {
        // let res = await api.jobs.getBanner({position: '71'})
        // if(res.code == 1000) {
        //   this.checkBanner = res.data[0]
        // }
        // console.log(this.readyScore,111111);
        // let res =await api.jobs.getBanner({position: 85})
        // console.log(res,22222);
        // for (let index = 0; index < res.data.length; index++) {
        //   this.imgbanner.push(res.data[index])
        // }
        // let res2 =await api.jobs.getBanner({position: 86})
        // console.log(res2,2222333);
        // for (let index = 0; index < res2.data.length; index++) {
        //   this.imgbanner2.push(res2.data[index])
        // }
      },
      toLink(item) {
        // alert(166666)
        if(!item.link) return
        window.open(item.link,"_blank")
        // console.log(5555,item);
      },
      downloadApp () {
				this.$emit('downloadApp')
      },
			async check () {
				if (this.ischecked) {
					return false
				}
				// this.setCheckData({
				//   score: 0,
				//   suggestions: this.checkData
				// })
				this.ischecked = true
				let { basic_info: { token } } = this.cvDetail
        this.$emit('checkClick')
				if (this.notMemberAgainCheck) {
					this.$message.error('该功能为会员专享')
					this.ischecked = false
					const alertData = {
						show: true,
						type: 'upVip',
            browseType: 'cvCheck'
					}
					this.setAlertData(alertData)
				} else {
          // console.log(1111111,"=================>")
					let checkRes = await this.getCheckData({ needDealCheck: false, clickCheck: true })
          this.ischecked = false
          // 没有检查次数了
          if(checkRes.code === 2030){
            this.$message.success('智能检查次数不足')
            const alertData = {
            	show: true,
            	type: 'upVip',
              browseType: 'cvCheck'
            }
            this.setAlertData(alertData)
          }else if(checkRes.code === 1000){
            setTimeout(() => {
              this.$message.success('完成智能检查')
            }, 2000)
            await this.getCvPortrait(token)
            let time = moment().format('YYYY-MM-DD')
            localStorage.setItem(`${ token }-check`, time)
            localStorage.setItem(`${ token }-checkData`, JSON.stringify(this.checkData))
          }else if(checkRes.code === 600213){
            this.$message.success(checkRes.message)
            const alertData = {
            	show: true,
            	type: 'upVip',
              browseType: 'cvCheck'
            }
            this.setAlertData(alertData)
          }
				}
			},
      async toTestPage(){
        let res = await api.jobs.checkResume(this.$route.params.token)
        if(res.code === 1000){
          if(!res.data.result){
            this.$message.error(`请先填写 ${res.data.msg} 信息，再尝试～`)
            return
          }
        }else if(res.code === 201201){
          this.$message.error(`请先填写 【姓名】、【学校名称】、【学历】、【专业信息】，再尝试～`)
          return
        }
        this.setIsShowJobscanGuide(false)
        window.open(`/jobscan/index/?token=${this.$route.params.token}&name=${this.cvDetail.basic_info.cv_name}`)
      },
      // 获取在线简历数据
      getRecommendCvData() {
        let user = get_tUser()
        if (user && user.c_t) {
          api.cvsV2.getOnlineCv(user.c_t).then(res => {
            this.hasRecommendCv = (res.code === 1000 || res.code === 80139)
          }).catch(e => console.log(e))
        }
        // api.cvsV2.getOnlineCv()
      },
		},
	}
</script>
<style lang="scss" scoped>
  .check {
    position: absolute;
    padding: 8px 0 0;
    width: 324px;
    box-sizing: border-box;
    background-color: #FFffff;
    // border-bottom: 6px solid #f9f9f9;
    top: 0;
    z-index: 8;
    /*border-radius: 2px 2px 0 0;*/

    .check-box {
      position: relative;
      width: 304px;
      height: 157px;
      margin: 0 auto;
      background-image: url('https://files.wondercv.com/pc-vue/editor/check-score-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding: 0 20px 0;
      box-sizing: border-box;
    }

    .check-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .score-content {
        color: #ffffff;
        .score-number {
          display: inline-block;
          font-size: 42px;
          margin-right: 2px;
          font-weight: 600;
        }
        .score-text {
          font-size: 16px;
        }
      }
      /*span {*/
      /*  color: #404040;*/
      /*  font-size: 14px;*/
      /*  font-weight: 600;*/
      /*}*/
      button {
        width: 90px;
        height: 30px;
        color: #FF6644;
        background-color: #FFffff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 15px;
        &:hover{
          opacity: 0.9;
        }
      }
    }

    .check-progress {
      height: 4px;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.2);
      margin-top: 10px;
      margin-bottom: 2px;
      div {
        width: auto;
        height: 100%;
        border-radius: 2px;
        background: #ffffff;
        /*transition: all .35s ease;*/
      }
    }

    .mentor-entry-box {
      display: flex;
      align-items: center;

      .mentor-entry-avatar {
        margin-left: -8px;
        width: 104px;
        height: 60px;
        cursor: pointer;
        background-image: url('https://files.wondercv.com/pc-vue/editor/mentor-entry-avatar.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        &:hover {
          .mentor-entry-image {
            display: block;
          }
        }

        .mentor-entry-image {
          display: none;
          width: 292px;
          height: 223px;
          position: absolute;
          left: 6px;
          top: 135px;
          z-index: 10;
          background-image: url('https://files.wondercv.com/pc-vue/editor/mentor-entry-bg.png');
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
      }

      >p {
        font-size: 13px;
        font-weight: 400;
        color: #F9F9F9;
        line-height: 18px;
        text-align: justify;
      }
    }

    .privacy-entry-box {
      position: relative;
      width: 292px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #F4F4F4;
      box-sizing: border-box;
      margin: 0 auto;
      overflow: hidden;
      z-index: -1;
      >p {
        font-size: 14px;
        font-weight: 400;
        color: #404040;
        line-height: 20px;
      }

      >a {
        position: relative;
        display: inline-block;
        width: 56px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 12px;
        box-sizing: border-box;
        background: #ffffff;
        font-size: 12px;
        font-weight: 400;
        color: #FF6644;

        &:hover {
          color: #ffffff;
          background: #FF6644;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          box-sizing: border-box;
          border-radius: 24px;
          width: 200%;
          height: 200%;
          border: 1px solid #FF6644;
          transform: scale(0.5,0.5);
          transform-origin: 0 0;
        }
      }

      .privacy-entry-bg {
        position: absolute;
        left: -20px;
        bottom: -26px;
        width: 62px;
        height: 65px;
      }

    }



    .check-msg {
      margin-top: 16px;
      color: #404040;
      line-height: 22px;
      font-size: 14px;
      p{
        margin-bottom: 8px;
      }
      /deep/ .jobs-button {
        color: #FF6644;
        text-decoration: underline;
        &:hover {
          font-weight: 600;
        }
      }
      .check-item {
        display: flex;
        align-items: center;
        a {
          margin-left: 4px;
          color: #ff6644;
          text-decoration: underline;
        }
      }
    }
    .sync-success {
      margin-top: 16px;
      span {
        color: #404040;
        line-height: 22px;
      }
      .set-high-light {
        color: #ff6644;
        font-weight: 600;
      }
    }
    .download-app-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      button {
        margin-top: 12px;
        height: 42px;
        background-color: #FFffff;
        color: #ff6644;
        border: 1px solid #ff6644;
        border-radius: 24px;
        &:hover {
          background-color: #ff6644;
          color: #FFffff;
        }
      }
    }
    .check-btn {
      display: block;
      height: 36px;
      line-height: 36px;
      text-align: center;
      align-items: center;
      color: #FF6644;
      border: 1px solid #FF6644;
      border-radius: 18px;
      &:hover {
        color: #fff;
        background: #FF6644;
      }
    }
    .check-banner{
      width: 292px;
      //height: 92px;
      height: 100%;
      border-radius: 6px;
      margin: 0 auto;
      display: block;
    }
    .jobscan-box{
      background: url("https://files.wondercv.com/pc-vue/editor/jobscan-entry-bg.png");
      width: 292px;
      height: 92px;
      border-radius: 4px;
      margin: 0 auto 16px;
      background-size: 100% 100%;
      padding: 14px 20px;
      box-sizing: border-box;
      cursor: pointer;
      box-shadow: 0px 0px 28px rgba(221, 221, 221, 0.8);

      .jobscan-title{
        font-size: 16px;
        font-weight: 600;
        color: #404040;
        line-height: 20px;
        margin-bottom: 6px;
      }
      .jobscan-content{
        font-size: 12px;
        font-weight: 400;
        color: #404040;
        line-height: 18px;
      }
    }
  }
  .jobscan-active{
    position: relative;
    z-index: 10;
  }
  .jobscan-layer{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 130px;
    background-color: rgba(0,0,0,0.6);

    &.jobscan-layer-bottom {
      bottom: 0;
      top: 266px;
    }
  }
  .edit_body {
    // background-color: #fff;
    ::v-deep .el-carousel {
      .el-carousel__indicators {
        display: block;
        .el-carousel__button {
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background: rgba(255, 255, 255, 0.3);
        }
        .el-carousel__indicator.is-active .el-carousel__button {
          background: #FFFFFF;
        }
      }

    }
  }
    /deep/ .el-carousel__container{
        // height: 79px;
        height: 92px;
    }

    .more-banner {
      /deep/ .el-carousel {
        .el-carousel__container{
          button {
            display: none;
          }
        }
        .el-carousel__indicators {
          display: none;
        }
      }
    }

</style>
